export default "__VITE_ASSET__DHHANigD__"